import { render, staticRenderFns } from "./wrongQuestionDetail.vue?vue&type=template&id=69ddf49b&scoped=true&"
import script from "./wrongQuestionDetail.vue?vue&type=script&lang=js&"
export * from "./wrongQuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./wrongQuestionDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wrongQuestionDetail.vue?vue&type=style&index=1&id=69ddf49b&lang=scss&scoped=true&"
import style2 from "./wrongQuestionDetail.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ddf49b",
  null
  
)

export default component.exports